import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Star, PawPrint } from 'lucide-react';
const reviews = [{
  quote: "Absolutely amazing service! They pulled right up to our house and took such great care of Bella. She's usually anxious, but she loved her groomer.",
  pet: 'Bella',
  owner: 'Sarah M.'
}, {
  quote: "The new Goodyear salon is beautiful and so clean. I love that they don't use cages. Max came out looking incredibly handsome and smelling great.",
  pet: 'Max',
  owner: 'David T.'
}, {
  quote: "Best grooming experience we've ever had. The blueberry facial is a game changer. Highly recommend The Valley to anyone in the West Valley!",
  pet: 'Luna',
  owner: 'Jessica R.'
}, {
  quote: "Professional, on time, and so gentle with our senior dog. It's such a relief not having to drive him to a loud, stressful shop anymore.",
  pet: 'Charlie',
  owner: 'Michael B.'
}];
const AUTO_ADVANCE_MS = 4000;
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef<number | null>(null);
  const touchEndX = useRef<number | null>(null);
  const goTo = useCallback((index: number) => {
    setCurrent((index + reviews.length) % reviews.length);
  }, []);
  const next = useCallback(() => goTo(current + 1), [current, goTo]);
  const prev = useCallback(() => goTo(current - 1), [current, goTo]);
  // Auto-advance, paused on hover / recent interaction
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % reviews.length);
    }, AUTO_ADVANCE_MS);
    return () => clearInterval(timer);
  }, [isPaused, current]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = null;
    setIsPaused(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const delta = touchStartX.current - touchEndX.current;
      if (Math.abs(delta) > 50) {
        if (delta > 0) next();else prev();
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
    // Briefly pause after a swipe, then resume auto-advance with a fresh timer
    setIsPaused(true);
    window.setTimeout(() => setIsPaused(false), AUTO_ADVANCE_MS);
  };
  return <section className="py-24 bg-brand-dark text-brand-light overflow-hidden" data-id="element-218">
      <div className="container mx-auto px-6 md:px-12" data-id="element-219">
        <div className="text-center mb-16" data-id="element-220">
          <h2 className="text-4xl md:text-5xl font-heading mb-4 flex items-center justify-center gap-3" data-id="element-221">
            Happy Tails{' '}
            <Star className="text-brand-orange fill-brand-orange" size={36} data-id="element-222" />
          </h2>
        </div>

        {/* Carousel */}
        <div className="max-w-2xl mx-auto px-6" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-223">
          <div className="overflow-hidden" data-id="element-224">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${current * 100}%)`
          }} data-id="element-225">
              {reviews.map((review, index) => <div key={index} className="w-full flex-shrink-0 px-1" data-id="element-226">
                  <div className="bg-brand-charcoal p-8 rounded-3xl border border-brand-pink/20 relative h-full" data-id="element-227">
                    <PawPrint className="absolute top-6 right-6 text-brand-pink/10" size={48} data-id="element-228" />
                    <div className="flex gap-1 mb-6" data-id="element-229">
                      {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-brand-orange fill-brand-orange" data-id="element-230" />)}
                    </div>
                    <p className="text-brand-light/90 text-lg mb-8 italic relative z-10" data-id="element-231">
                      "{review.quote}"
                    </p>
                    <div className="flex items-center gap-3" data-id="element-232">
                      <div className="w-12 h-12 bg-brand-pink/20 rounded-full flex items-center justify-center text-brand-pink font-heading text-xl" data-id="element-233">
                        {review.pet[0]}
                      </div>
                      <div data-id="element-234">
                        <p className="font-semibold" data-id="element-235">{review.pet}</p>
                        <p className="text-sm text-brand-light/60" data-id="element-236">
                          {review.owner}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Dot indicators */}
          <div className="flex justify-center gap-2 mt-8" role="tablist" aria-label="Testimonials" data-id="element-237">
            {reviews.map((_, index) => <button key={index} onClick={() => {
            goTo(index);
            setIsPaused(true);
            window.setTimeout(() => setIsPaused(false), AUTO_ADVANCE_MS);
          }} aria-label={`Go to testimonial ${index + 1}`} aria-selected={current === index} role="tab" className={`h-2.5 rounded-full transition-all duration-300 ${current === index ? 'w-8 bg-brand-orange' : 'w-2.5 bg-brand-light/30 hover:bg-brand-light/50'}`} data-id="element-238" />)}
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-239">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-pink-400 font-semibold inline-flex items-center transition-colors" data-id="element-240">
            Follow Us @TheValleyGrooming <span className="ml-2" data-id="element-241">→</span>
          </a>
        </div>
      </div>
    </section>;
}